import { useState, useEffect } from "react";

const useTimer = (createdAt, statusId, endedAt = null) => {
    const [elapsed, setElapsed] = useState(0);

    const isFinished = statusId === 5 || statusId === 6;

    useEffect(() => {
        if (!createdAt) return;

        if (isFinished) {
            const end = endedAt ? new Date(endedAt) : new Date();
            const diff = Math.max(0, Math.floor((end - new Date(createdAt)) / 1000));
            setElapsed(diff);
            return;
        }

        const tick = () => {
            const diff = Math.max(0, Math.floor((Date.now() - new Date(createdAt)) / 1000));
            setElapsed(diff);
        };

        tick();
        const interval = setInterval(tick, 1000);
        return () => clearInterval(interval);
    }, [createdAt, statusId, endedAt]);

    const days    = Math.floor(elapsed / 86400);
    const hours   = Math.floor((elapsed % 86400) / 3600);
    const minutes = Math.floor((elapsed % 3600) / 60);
    const seconds = elapsed % 60;

    return { days, hours, minutes, seconds, isOngoing: !isFinished };
};

export default useTimer;